import React from 'react';
import { useToast } from '../../context/ToastContext';
import SiteIcon from './SiteIcon';

/**
 * Értesítések — a sablon `.toast`-ja (2026-10-04): jobb alul, kiemelt panel-lap erős
 * kerettel; a fajtáját az ikon színe mondja meg. Kattintásra eltűnik.
 * A rétegsor: ablak (240) < lightbox (245) < értesítés (250), hogy egy ablakban
 * kiváltott hiba is látsszon.
 */
const KINDS = {
  success: { icon: 'check', cls: 'text-ok' },
  error:   { icon: 'alert', cls: 'text-danger' },
  info:    { icon: 'info',  cls: 'text-brand-500' },
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed right-4 sm:right-5 bottom-[calc(20px+env(safe-area-inset-bottom,0px))] z-[250]
                    flex flex-col items-end gap-2 pointer-events-none">
      {toasts.map(t => {
        const k = KINDS[t.type] || KINDS.info;
        return (
          <div
            key={t.id}
            onClick={() => removeToast(t.id)}
            role={t.type === 'error' ? 'alert' : 'status'}
            className="pointer-events-auto min-w-[220px] max-w-[340px] px-3.5 py-[11px] flex items-start gap-2.5
                       rounded-panel bg-gray-850 border border-line-strong shadow-[0_20px_40px_-20px_rgba(0,0,0,0.9)]
                       text-[13px] text-gray-50 cursor-pointer animate-toast-in"
          >
            <SiteIcon name={k.icon} className={`mt-px w-4 h-4 ${k.cls}`} />
            <p className="leading-snug">{t.message}</p>
          </div>
        );
      })}
    </div>
  );
}
